import HeaderTools from "../../../../Components/ComponentsIndustry/HeaderTools";
import TopShipping from "../../../../Components/ComponentsIndustry/TopShipping";
import FooterButton from "../../../../Components/ComponentsIndustry/FooterButton";
import axios from 'axios';
import React, { useEffect, useState } from "react";
import { useSausage } from "../../../../providers/SausageContext";

import {
  Container,
  ContainerCard,
  SizeContainer,
  MainContainer,
  SubTitle,
  TotalsContainer,
  TotalsDifferent,
  NegociationAproved,
  RequestContainer,
  FirstRequestContainer,
  Header,
  MiddleContent,
  Footer
} from "./styles";
import { useCommercialSales } from "../../../../providers/CommercialSalesContext";
import { useUser } from "../../../../providers/UserContext";
import ItemShipping from "../../../../Components/ComponentsIndustry/ItemShipping";
import { useFries } from "../../../../providers/FriesContext";
import { useCutChicken } from "../../../../providers/CutChickenContext";
import { useChicken } from "../../../../providers/ChickenContext";

const ToolsShipping = () => {

  const { approvedNegociations, getApprovedNegociation } = useCommercialSales()
  const { rodada } = useUser()

  const [caixas, setCaixas] = useState(0)
  const [alertTruck, setAlertTruck] = useState('')
  const [alert3x4, setAlert3x4] = useState('')
  const [alertCarreta, setAlertCarreta] = useState('')

  const { getSausageStock } = useSausage()
  const { getFriesStock } = useFries()
  const { getChickenStock } = useChicken()
  const { getCutChickenStock } = useCutChicken()

  const arrayFrotas = [
    {
      "cargaCaixas": 0.3,
      "cargaKg": 4000,
      "custoTotal": 0,
      "custoViagem": 950,
      "viagens": 0,
      "img": "shipping_1.svg"
    },
    {
      "cargaCaixas": 0.63,
      "cargaKg": 12000,
      "custoTotal": 0,
      "custoViagem": 2000,
      "viagens": 0,
      "img": "shipping_2.svg"
    },
    {
      "cargaCaixas": 0.94,
      "cargaKg": 24000,
      "custoTotal": 0,
      "custoViagem": 3000,
      "viagens": 0,
      "img": "shipping_3.svg"
    }
  ]

  const [frota3x4, setFrota3x4] = useState(0);
  const [frotaTruck, setFrotaTruck] = useState(0);
  const [frotaCarreta, setFrotaCarreta] = useState(0);
  const [qtdSelecionada, setQtdSelecionada] = useState(0);
  const [qtdSelecionadaTruck, setQtdSelecionadaTruck] = useState(0);
  const [qtdSelecionadaCarreta, setQtdSelecionadaCarreta] = useState(0);
  const [caixasRestantes, setCaixasRestantes] = useState(0)
  const [selectedMarketNegociation, setSelectedMarketNegociation] = useState({})

  const clearAll = () => {
    setFrota3x4(0)
    setFrotaTruck(0)
    setFrotaCarreta(0)
    setQtdSelecionada(0)
    setQtdSelecionadaTruck(0)
    setQtdSelecionadaCarreta(0)
    setCaixasRestantes(0)
    setSelectedMarketNegociation(0)
  }
  const handleShipping = () => {
    const data = {
      "cam3x4CargaCaixas": caixas,
      "cam3x4CargaKg": caixas,
      "cam3x4CustoTotal": frota3x4 * 950,
      "cam3x4CustoViagem": frota3x4 * 950,
      "cam3x4Viagens": frota3x4,
      "camCarretaCargaCaixas": caixas,
      "camCarretaCargaKg": caixas,
      "camCarretaCustoTotal": frotaCarreta * 2000,
      "camCarretaCustoViagem": frotaCarreta * 2000,
      "camCarretaViagens": frotaCarreta,
      "camTruckCargaCaixas": caixas,
      "camTruckCargaKg": caixas,
      "camTruckCustoTotal": caixas,
      "camTruckCustoViagem": frotaTruck * 3000,
      "camTruckViagens": frotaTruck * 3000,
      "codVenda": selectedMarketNegociation.venda,
      "codRodada": rodada?.rodada,
    }

    axios({
      method: "POST",
      url: "https://sistemas.sisinfor.com.br/BusinessGameBack/api/logistica/cadastrar",
      data: data
    })
      .then(response => {
        if (response.data.sucesso) {
          alert("Produto enviado com sucesso")
          getApprovedNegociation()
          clearAll()
        }
      })
  }

  const handleFrota3x4 = (e) => {
    setFrota3x4(e.target.value)

    if (e.target.value >= 1) {

      if (e.target.value > frota3x4) {

        if (caixasRestantes > arrayFrotas[0]?.cargaKg) {
          if (qtdSelecionada + (arrayFrotas[0]?.cargaKg * e.target.value) > caixas) {
            setQtdSelecionada(caixas)
            setAlert3x4(`Há ${(qtdSelecionada + (arrayFrotas[0]?.cargaKg * e.target.value) - caixas) / 1000} ton remanescentes nas frotas contratadas`)
          } else {
            setAlert3x4("")
            setQtdSelecionada(qtdSelecionada + (arrayFrotas[0]?.cargaKg * e.target.value))
          }
          setCaixasRestantes(caixasRestantes - (arrayFrotas[0]?.cargaKg * e.target.value) > caixasRestantes ? 0 : caixasRestantes - (arrayFrotas[0]?.cargaKg * e.target.value))
        } else {
          setQtdSelecionada(qtdSelecionada + caixasRestantes)
          setCaixasRestantes(0)
        }

      } else {

        if (caixasRestantes > arrayFrotas[0]?.cargaKg) {
          if (qtdSelecionada + (arrayFrotas[0]?.cargaKg * e.target.value) > caixas) {
            setQtdSelecionada(caixas)
            setAlert3x4(`Há ${(qtdSelecionada + (arrayFrotas[0]?.cargaKg * e.target.value) - caixas) / 1000} ton remanescentes nas frotas contratadas`)
          } else {
            setAlert3x4("")
            setQtdSelecionada(qtdSelecionada + (arrayFrotas[0]?.cargaKg * e.target.value))
          }
          setCaixasRestantes(caixasRestantes - (arrayFrotas[0]?.cargaKg * e.target.value) > caixasRestantes ? 0 : caixasRestantes - (arrayFrotas[0]?.cargaKg * e.target.value))
        } else {
          setQtdSelecionada(qtdSelecionada + caixasRestantes)
          setCaixasRestantes(0)
        }
        // setQtdSelecionada(qtdSelecionada - arrayFrotas[0]?.cargaKg <= 0 ? 0 : qtdSelecionada - arrayFrotas[0]?.cargaKg)
        // setCaixasRestantes(caixasRestantes + arrayFrotas[0]?.cargaKg >= caixas ? caixas : caixasRestantes + arrayFrotas[0]?.cargaKg)

      }

    } else {

      setAlert3x4("")
      setQtdSelecionada(0)
      setCaixasRestantes(caixas)

    }

  }

  const handleFrotaTruck = (e) => {
    setFrotaTruck(e.target.value)

    if (e.target.value >= 1) {
      if (e.target.value > frotaTruck) {

        if (caixasRestantes > arrayFrotas[1]?.cargaKg) {
          if (qtdSelecionadaTruck + (arrayFrotas[1]?.cargaKg * e.target.value) > caixas) {
            setQtdSelecionadaTruck(caixas)
            setAlertTruck(`Há ${(qtdSelecionadaTruck + (arrayFrotas[1]?.cargaKg * e.target.value) - caixas) / 1000} ton remanescentes nas frotas contratadas`)
          } else {
            setAlertTruck("")
            setQtdSelecionadaTruck(qtdSelecionadaTruck + (arrayFrotas[1]?.cargaKg * e.target.value))
          }
          setCaixasRestantes(caixasRestantes - (arrayFrotas[1]?.cargaKg * e.target.value) > caixasRestantes ? 0 : caixasRestantes - (arrayFrotas[1]?.cargaKg * e.target.value))
        } else {
          setQtdSelecionadaTruck(qtdSelecionadaTruck + caixasRestantes)
          setCaixasRestantes(0)
        }

      } else {

        setQtdSelecionadaTruck(qtdSelecionadaTruck - arrayFrotas[1]?.cargaKg <= 0 ? 0 : qtdSelecionadaTruck - arrayFrotas[1]?.cargaKg)
        setCaixasRestantes(caixasRestantes + arrayFrotas[1]?.cargaKg >= caixas ? caixas : caixasRestantes + arrayFrotas[1]?.cargaKg)

      }

    } else {

      setAlertTruck("")
      setQtdSelecionadaTruck(0)
      setCaixasRestantes(caixas)

    }
  }

  const handleFrotaCarreta = (e) => {
    setFrotaCarreta(e.target.value)

    if (e.target.value >= 1) {
      if (e.target.value > frotaCarreta) {

        if (caixasRestantes > arrayFrotas[2]?.cargaKg) {
          if (qtdSelecionadaCarreta + (arrayFrotas[2]?.cargaKg * e.target.value) > caixas) {
            setQtdSelecionadaCarreta(caixas)
            setAlertCarreta(`Há ${(qtdSelecionadaCarreta + (arrayFrotas[2]?.cargaKg * e.target.value) - caixas) / 1000} ton remanescentes nas frotas contratadas`)
          } else {
            setAlertCarreta("")
            setQtdSelecionadaCarreta(qtdSelecionadaCarreta + (arrayFrotas[2]?.cargaKg * e.target.value))
          }
          setCaixasRestantes(caixasRestantes - (arrayFrotas[2]?.cargaKg * e.target.value) > caixasRestantes ? 0 : caixasRestantes - (arrayFrotas[2]?.cargaKg * e.target.value))
        } else {
          setQtdSelecionadaCarreta(qtdSelecionadaCarreta + caixasRestantes)
          setCaixasRestantes(0)
        }

      } else {

        setQtdSelecionadaCarreta(qtdSelecionadaCarreta - arrayFrotas[2]?.cargaKg <= 0 ? 0 : qtdSelecionadaCarreta - arrayFrotas[2]?.cargaKg)
        setCaixasRestantes(caixasRestantes + arrayFrotas[2]?.cargaKg >= caixas ? caixas : caixasRestantes + arrayFrotas[2]?.cargaKg)

      }

    } else {

      setAlertCarreta("")
      setQtdSelecionadaCarreta(0)
      setCaixasRestantes(caixas)

    }
  }

  useEffect(() => {

    getApprovedNegociation()
    getSausageStock()
    getFriesStock()
    getChickenStock()
    getCutChickenStock()

  }, [])

  useEffect(() => {
    setCaixasRestantes(caixas)
  }, [caixas])

  function handleTotalCif() {

    if (isNaN(parseFloat(frota3x4) * 950 + parseFloat(frotaTruck) * 2000 + parseFloat(frotaCarreta) * 3000)) {
      return 0
    } else {
      return parseFloat(frota3x4) * 950 + parseFloat(frotaTruck) * 2000 + parseFloat(frotaCarreta) * 3000
    }

  }

  return (
    <Container>
      <SizeContainer>
        <HeaderTools
          pathImg="./images/shipping_button.svg"
          title="Logística"
          subTitle="(Frota e Frete)"
          style={["", "", "", "", "selection"]}
        />
        <TopShipping />
        <MainContainer>
          <SubTitle>
            <img src="./images/shipping_icon.svg" alt="shipping_icon" />
            Frete
          </SubTitle>
          <h2>
            Negociações Fechadas
          </h2>

          <RequestContainer>
            {
              approvedNegociations?.map(item => {
                return (
                  <FirstRequestContainer >
                    <NegociationAproved onClick={() => {
                      setSelectedMarketNegociation(item)
                      setCaixas(0)
                      let caixasAjuda = 0
                      item.itens.forEach(element => {
                        caixasAjuda = caixasAjuda + element.quantidade
                      })
                      setCaixas(caixasAjuda)
                    }}>
                      {item.supermercado.nome}
                    </NegociationAproved>

                    {
                      selectedMarketNegociation.venda === item.venda
                      &&
                      <>
                        <ItemShipping peso={caixas} setPeso={setCaixas} venda={item} />
                      </>
                    }


                  </FirstRequestContainer>

                )
              })}
          </RequestContainer>
          <h2 style={{ marginTop: "-70px" }}>Caixas a serem transportadas: {caixas}</h2>
          <ContainerCard>
            <Header>
              <img src={`./images/${arrayFrotas[0].img}`} alt="shipping_icon" />
              <h3>N° de Frotas</h3>
              <input value={frota3x4} onChange={(e) => handleFrota3x4(e)} placeholder="0" />
            </Header>
            <MiddleContent>
              <h3>
                Capacidade de <span>Caixas</span>
              </h3>
              <p>
                {arrayFrotas[0]?.cargaKg / 1000} <span>ton</span>
                <img src="./images/shipping_icon.svg" alt="shipping_icon" />
              </p>
            </MiddleContent>

            <Footer>
              <h3>
                Carga <span>Selecionada</span>
              </h3>
              <p>
                {qtdSelecionada} <img src="./images/unit_cost.svg" alt="unit_cost" />
              </p>
            </Footer>
            {caixasRestantes > 0 &&
              <Footer>
                Caixas restantes:{caixasRestantes}
              </Footer>
            }
            <Footer>
              {alert3x4}
            </Footer>
          </ContainerCard>
          <ContainerCard>
            <Header>
              <img src={`./images/${arrayFrotas[1].img}`} alt="shipping_icon" />
              <h3>N° de Frotas</h3>
              <input value={frotaTruck} onChange={(e) => handleFrotaTruck(e)} placeholder="0" />
            </Header>
            <MiddleContent>
              <h3>
                Capacidade de <span>Caixas</span>
              </h3>
              <p>
                {arrayFrotas[1]?.cargaKg / 1000} <span>ton</span>
                <img src="./images/shipping_icon.svg" alt="shipping_icon" />
              </p>
            </MiddleContent>

            <Footer>
              <h3>
                Carga <span>Selecionada</span>
              </h3>
              <p>
                {qtdSelecionadaTruck} <img src="./images/unit_cost.svg" alt="unit_cost" />
              </p>
            </Footer>
            {caixasRestantes > 0 &&
              <Footer>
                Caixas restantes:{caixasRestantes}
              </Footer>
            }
            <Footer>
              {alertTruck}
            </Footer>
          </ContainerCard>
          <ContainerCard>
            <Header>
              <img src={`./images/${arrayFrotas[2].img}`} alt="shipping_icon" />
              <h3>N° de Frotas</h3>
              <input value={frotaCarreta} onChange={(e) => handleFrotaCarreta(e)} placeholder="0" />
            </Header>
            <MiddleContent>
              <h3>
                Capacidade de <span>Caixas</span>
              </h3>
              <p>
                {arrayFrotas[2]?.cargaKg / 1000} <span>ton</span>
                <img src="./images/shipping_icon.svg" alt="shipping_icon" />
              </p>
            </MiddleContent>

            <Footer>
              <h3>
                Carga <span>Selecionada</span>
              </h3>
              <p>
                {qtdSelecionadaCarreta} <img src="./images/unit_cost.svg" alt="unit_cost" />
              </p>
            </Footer>
            {caixasRestantes > 0 &&
              <Footer>
                Caixas restantes:{caixasRestantes}
              </Footer>
            }
            <Footer>
              {alertCarreta}
            </Footer>
          </ContainerCard>

          <TotalsContainer>
            <img src="./images/unit_cost.svg" alt="unit_cost" />
            <div>
              <h4>Carga total</h4>
              <p>
                {caixas} <img src="./images/box.svg" alt="box" />
              </p>
            </div>
            <p>
              {caixas} <img src="./images/kg.svg" alt="kg" />
            </p>
          </TotalsContainer>

          <TotalsDifferent>
            <img src="./images/shipping_button.svg" alt="shipping_button" />
            <h4>Frete total</h4>
            <p>{handleTotalCif()}</p>
          </TotalsDifferent>

          {/* <TotalsDifferent>
            <img src="./images/ticket.svg" alt="ticket" />
            <h4>Preço CIF</h4>
            <p>
              {handleTotalCif()} <img src="./images/cifrao.svg" alt="cifrao" />
            </p>
          </TotalsDifferent> */}
        </MainContainer>
        <FooterButton onHandle={handleShipping} text="Confirmar" />
      </SizeContainer>
    </Container>
  );
};
export default ToolsShipping;
